import React, { useState, useEffect } from "react";
import {
  Box,
  MenuItem,
  Select,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import SearchBox from "../../AdminComponents/Common/SearchBox";
import PaginationDataTable from "../../AdminComponents/Common/PaginationDataTable";
import Heading from "../../AdminComponents/Common/Heading";
import CustomButton from "../../Components/Common/CustomButton";
import { BASE_URL } from "../../Assets/Constants";
import { toast } from "react-toastify";
import { theme } from "../../Assets/Theme/theme";

function Barcode() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState("all");
  const [barcodeData, setBarcodeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const loginData = JSON.parse(localStorage.getItem("adminData"));
  const token = loginData?.token;

  console.log(token, "TOKEN");

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  useEffect(() => {
    const filtered = barcodeData.filter((item) => {
      return (
        item.barcode.toLowerCase().includes(searchTerm) &&
        (filter === "all" || item.status.toLowerCase() === filter.toLowerCase())
      );
    });

    setFilteredData(filtered);
  }, [searchTerm, filter, barcodeData]);

  const fetchBarcodeData = async () => {
    try {
      setLoading(true);

      const loginData = JSON.parse(localStorage.getItem("adminData"));
      const token = loginData?.token;

      if (!token) {
        toast.error("Authentication token is missing", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        navigate('/login')
        return;
      }

      const response = await axios.get(`${BASE_URL}/admin/barcodes`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const rowsData = response?.data?.data?.map((item, index) => ({
        sNo: index + 1,
        barcode: item?.barcode,
        type: item?.type,
        experience: item?.experience?.name || 'Undefined',
        status: item?.status,
        action: null,
        _id: item?._id,
      }));

      setBarcodeData(rowsData);
      setFilteredData(rowsData);
    } catch (error) {
      console.error("Error fetching barcode data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBarcodeData();
  }, []);


  const handleEdit = async (user) => {
    try {
      if (!token) {
        toast.error("Authentication token is missing", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        navigate('/login')
        return;
      }

      const response = await axios.get(
        `${BASE_URL}/admin/barcode/${user?._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const barcodeDetails = response.data;

      navigate("/admin/barcode/edit", { state: { barcodeDetails } });
    } catch (error) {
      console.error("Error fetching barcode details:", error);
    }
  };

  const columns = [
    { id: "S.no", name: "S.no" },
    { id: "barcode", name: "Barcode" },
    { id: "type", name: "Category" },
    { id: "experience", name: "Experience" },
    { id: "status", name: "Status" },
    { id: "action", name: "Action" },
  ];

  const handleOpenModal = (id) => {
    setSelectedId(id);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedId(null);
  };

  const onDelete = async () => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/admin/barcode/${selectedId}/delete`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setBarcodeData((prevData) =>
        prevData.filter((item) => item._id !== selectedId)
      );
      toast.success(response?.data?.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        style: { backgroundColor: 'orange', color: 'white' },
      });
      fetchBarcodeData()
    } catch (error) {
      console.error("Error deleting experience:", error);
      toast.error("Failed to delete barcode. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      handleCloseModal();
    }
  };

  const [currentPage, setCurrentPage] = useState(0); 

  const handleSearchChange = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    setCurrentPage(0);

    setFilteredData(
      barcodeData.filter((item) => item.barcode.toLowerCase().includes(value))
    );
  };


  return (
    <Box>
      <Heading label={"Barcode"} />
      <Box
        mt={4}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <SearchBox
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder={"Search using barcode"}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            border: "none",
            gap: 2,
          }}
        >
          <Select
            value={filter}
            onChange={handleFilterChange}
            InputProps={{
              disableUnderline: true,
            }}
            sx={{
              minWidth: 120,
              backgroundColor: "#EEEEEE",
              fontWeight: "bold",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "& .MuiMenuItem-root": {
                fontWeight: "500",
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  "& .MuiMenuItem-root": {
                    fontWeight: "300",
                    "&:hover": {
                      backgroundColor: "#EEEEEE",
                      color: "#121212",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#FF7900",
                      color: "white",
                    },
                  },
                },
              },
            }}
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="used">Used</MenuItem>
            <MenuItem value="unused">Unused</MenuItem>
          </Select>

          {/* Add Button */}
          <CustomButton onClick={() => navigate("/admin/barcode/add")}>
            Add Barcode
          </CustomButton>
        </Box>
      </Box>

      <Box mt={4}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <CircularProgress size={30} sx={{ color: theme.colors.orange }} />
          </Box>
        ) : (
          <PaginationDataTable
            editAndDelete={true}
            columns={columns}
            rows={filteredData}
            onEdit={(user) => handleEdit(user)}
            onDelete={(user) => handleOpenModal(user._id)}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </Box>

      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this barcode?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="black" sx={{
            backgroundColor: theme.colors.orange,
            borderRadius: '5px',
            color: 'white',
            '&:hover': {
              backgroundColor: 'darkorange',
            },
          }}>
            Cancel
          </Button>
          <Button onClick={onDelete} color="primary" sx={{
            backgroundColor: theme.colors.red,
            borderRadius: '5px',
            color: 'white',
            '&:hover': {
              backgroundColor: '#FF474C',
            },
          }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Barcode;
